import * as React from 'react';

import { DemandTrapBanner } from '../../components/DemandTrapBanner';
import { RosbankPilotBannerContainer } from '../RosbankPilotBannerContainer';
import { useShowBanner } from './useShowBanner';

/**
 * Контейнер, где формируется баннер для add-form.jade
 */
export const BannerContainer: React.FC<React.ReactNode> = () => {
  const { showDemandTrapBanner, showRosbankPilotBanner, category } = useShowBanner();

  if (showDemandTrapBanner) {
    return <DemandTrapBanner dealType={category.dealType} />;
  } else if (showRosbankPilotBanner) {
    return <RosbankPilotBannerContainer />;
  } else {
    return null;
  }
};
